import moment from 'moment';
import { Fragment } from 'react/jsx-runtime';

import PageLayout from 'PageLayout';
import { EButton, EPageTitle, ESelect, ETable } from 'libs/ui';

import usePaymentRequest from './hooks/useAffiliatePaymentRequest';
import { useEffect } from 'react';

export default function PaymentRequest() {

    const {
        isLoading,
        paymentRequest,
        navigate,
        paymentRequestStatus,
        setPaymentRequestStatus,
        // goToNextPage,
        // goToPreviousPage,
        // disablePrev,
        // disableNext,
    } = usePaymentRequest();


    return (
        <PageLayout>
            <EPageTitle
                title="Payment Request"
                end={
                    <EButton
                        onClick={() => navigate("/affiliate/accounts/create")}
                    >Create New</EButton>
                }
            />
            <div>
                <div className='filter-container'>
                    <ESelect
                        label="Payment Request Status"
                        data={[{ label: "Pending", value: "PENDING" }, { label: "Approved", value: "APPROVED" }, { label: "Rejected", value: "REJECTED" }]}
                        value={paymentRequestStatus}
                        onChange={(value) => {
                            setPaymentRequestStatus(value as "PENDING" | "APPROVED" | "REJECTED")
                        }}
                    />
                </div>

                <ETable
                    loading={isLoading}
                    pagination
                >
                    <thead>
                        <tr>
                            <th>Beneficiary Name</th>
                            <th>Cheque Number</th>
                            <th>Depositor Bank</th>
                            <th>Depositor Account No.</th>
                            <th>Amount</th>
                            <th>Date of Deposit</th>
                            <th>Date of Issue</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>

                    <tbody>
                        {
                            paymentRequest.map((eachRequest, index) => (
                                <Fragment key={index + "_pay_req"}>
                                    <tr>
                                        <td>{eachRequest?.beneficiaryName ?? "-"} {eachRequest?.beneficiaryBank ? `(${eachRequest?.beneficiaryBank})` : "-"}</td>
                                        <td>{eachRequest?.chequeDdNumber ?? "-"}</td>
                                        <td>{eachRequest?.depositorBankName ?? "-"} {eachRequest?.depositorBankBranch ? `(${eachRequest?.depositorBankBranch})` : "-"}</td>
                                        <td>{eachRequest?.depositorBankAccountNumber ?? "-"}</td>
                                        <td>{eachRequest?.depositAmount ?? "-"}{eachRequest?.depositType ? ` (${eachRequest?.depositType})` : "-"}</td>
                                        <td>{eachRequest?.dateOfDeposit ? moment(eachRequest.dateOfDeposit).format("DD-MM-YYYY") : "-"}</td>
                                        <td>{eachRequest?.chequeDdIssueDate ? moment(eachRequest.chequeDdIssueDate).format("DD-MM-YYYY") : "-"}</td>
                                        <td>{eachRequest?.remarks ?? "-"}</td>
                                    </tr>
                                </Fragment>
                            ))
                        }
                    </tbody>
                </ETable>

            </div>
        </PageLayout>
    );

}
